module.exports = __webpack_public_path__ + "img/refresh-arrow.053142f9.svg";